<forgot-password-page>
  <div if="{locale}" class="container">
    <div class="forgot-card">
      <div if={!state.emailSent} class="request-form-state">
        <h2 class="text-accent">{locale?.t('forgotpassword_title')}</h2>
        <p class="form-description">{locale?.t('forgotpassword_description')}</p>

        <form onsubmit={handleSubmit}>
          <div class="form-group">
            <label for="email">{locale?.t('forgotpassword_emailaddress')}</label>
            <input
              type="email"
              id="email"
              name="email"
              autocomplete="email"
              value={state.email}
              oninput={handleEmailInput}
              required
              placeholder="{locale?.t('forgotpassword_emailplaceholder')}"
            />
          </div>

          <div if={state.error} class="error-alert">{state.error}</div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            disabled={state.sending || !state.email}
          >
            {state.sending ? locale?.t('forgotpassword_sending') : locale?.t('forgotpassword_sendbutton')}
          </button>
        </form>

        <div class="back-link">
          <a href="#/login" class="text-primary font-bold">
            <i class="icon-metalark-chevron-left me-1"></i>
            {locale?.t('forgotpassword_backtologin')}
          </a>
        </div>
      </div>

      <div if={state.emailSent} class="success-state">
        <div class="success-icon">✓</div>
        <h2>{locale?.t('forgotpassword_checkemail_title')}</h2>
        <p>
          <raw html="{locale?.t('forgotpassword_checkemail_message', { email: state.email })}"></raw>
        </p>
        <p class="security-note">{locale?.t('forgotpassword_securitynote')}</p>
        <div class="email-tips">
          <h3>{locale?.t('forgotpassword_didntreceive')}</h3>
          <raw html="{locale?.t('forgotpassword_tips')}"></raw>
        </div>
        <div class="actions">
          <a href="#/login" class="btn btn-primary">
            {locale?.t('forgotpassword_returntologin')}
          </a>
          <button onclick={resetForm} class="btn btn-text">
            {locale?.t('forgotpassword_trydifferent')}
          </button>
        </div>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      padding: 20px;
      border-radius: 20px;
    }

    .forgot-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 500px;
      width: 100%;
    }

    .request-form-state,
    .success-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .success-icon {
      font-size: 64px;
      color: #10b981;
      margin-bottom: 20px;
      text-align: center;
    }

    h2 {
      /*color: #1f2937;*/
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
    }

    h3 {
      color: #374151;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
      text-align: center;
    }

    .form-description {
      margin-bottom: 32px;
    }

    .security-note {
      font-size: 14px;
      color: #6b7280;
      margin-top: 16px;
    }

    .form-group {
      margin-bottom: 24px;
      text-align: left;
    }

    label {
      display: block;
      color: #374151;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;
    }

    input[type="email"] {
      width: 100%;
      padding: 12px 16px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.2s;
      box-sizing: border-box;
    }

    input[type="email"]:focus {
      outline: none;
      border-color: var(--color-primary);
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    .error-alert {
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .btn {
      padding: 8px 24px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      font-size: 16px;
      text-decoration: none;
      display: inline-block;
    }

    .btn-block {
      width: 100%;
      display: block;
    }

    .btn-primary {
      background: var(--color-primary);;
      color: white;
    }

    .btn-primary:hover:not(:disabled) {
      background:var(--color-primary);;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:disabled {
      background: #9ca3af;
      cursor: not-allowed;
    }

    .btn-text {
      background: transparent;
      color: var(--color-primary);;
      padding: 8px 16px;
    }

    .btn-text:hover {
      background: #f3f4f6;
    }

    .back-link {
      text-align: center;
      margin-top: 24px;
    }

    .email-tips {
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 20px;
      margin: 24px 0;
      text-align: left;
    }

    .email-tips ul {
      margin: 12px 0 0 0;
      padding-left: 20px;
    }

    .email-tips li {
      color: #6b7280;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 32px;
    }

    @media (min-width: 640px) {
      .actions {
        flex-direction: row;
        justify-content: center;
      }
    }

    .me-1 {
      margin-inline-end: 4px;
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'
    import raw from '../components/raw.tag'

    export default {
      components: {
        raw
      },

      state: {
        email: '',
        emailSent: false,
        sending: false,
        error: ''
      },

      handleEmailInput(e) {
        this.update({
          email: e.target.value,
          error: ''
        })
      },

      async handleSubmit(e) {
        e.preventDefault()

        const { email } = this.state

        if (!email) {
          this.update({ error: this.locale.t('forgotpassword_error_required') })
          return
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
          this.update({ error: this.locale.t('forgotpassword_error_invalid') })
          return
        }

        this.update({ sending: true, error: '' })

        try {
          const api = await getApi()
          const response = await api.post('/auth/password/reset/request', {
            email
          })

          if (response.data.success) {
            this.update({
              sending: false,
              emailSent: true,
              error: ''
            })
          } else {
            this.update({
              sending: false,
              error: response.data.message || this.locale.t('forgotpassword_error_sendfailed')
            })
          }
        } catch (error) {
          console.error('Password reset request error:', error)

          // For security, still show success even on error
          // This prevents email enumeration attacks
          this.update({
            sending: false,
            emailSent: true,
            error: ''
          })
        }
      },

      resetForm() {
        this.update({
          email: '',
          emailSent: false,
          sending: false,
          error: ''
        })
      }
    }
  </script>
</forgot-password-page>